export const convertMaybeDateToISOString = (maybeDate: Date | string) => {
  if (maybeDate instanceof Date) {
    return maybeDate.toISOString();
  }

  return String(maybeDate);
};
